import PropTypes from 'prop-types';
import Box from 'components/UI/Box/Box';
import { ROUTE_PATH } from 'routes';
import { Link } from 'react-router-dom';
import { ReactComponent as ImgArrowRight } from 'assets/icons/arrow-access-white.svg';
import * as animationData from 'assets/animations/notification.json';
import Lottie from 'react-lottie';
import { STEPS } from 'constants/registration';

const FLAGS_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const UserBoxFinishSignup = ({ literals }) => {
  return (
    <Box className='user-box-finish-signup mb-4' padding='sm'>
      <Link className='user-box-finish-signup-link' to={ROUTE_PATH.setRegistration(STEPS.IDENTITY_VALIDATION)}>
        <div className='user-box-finish-signup-animation'>
          <Lottie
            options={FLAGS_OPTIONS}
            height={40}
            width={40}
          />
        </div>
        <div>
          <h4>{literals.completeProfile}</h4>
          <p className='mb-0 text-sm'>{literals.completeProfileDescription}</p>
        </div>
        <ImgArrowRight />
      </Link>
    </Box>
  );
};

UserBoxFinishSignup.propTypes = {
  literals: PropTypes.object.isRequired,
};

export default UserBoxFinishSignup;
